import React, { useState, useRef } from "react";
import "./Transportation_of_building_materials.css";
import { Link } from "react-router-dom";
import ContactSection2 from "../Category/ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";
import { Helmet } from "react-helmet";

export default function Transportation_of_industrial_and_heavy_generators() {

  const seo = {
    title:
      "הובלת גנרטורים תעשייתיים | הובלת גנרטורים כבדים | ש.מ הובלות ומנופים",
    description:
      "שירותי הובלת גנרטורים תעשייתיים וכבדים למפעלים, חברות, קבלנים, אתרי בנייה, עסקים ולקוחות פרטיים. הובלת גנרטורים עם משאית ואפשרות לשילוב מנוף להרמה, פריקה והצבה בהתאם לתנאי השטח.",
    url:
      "https://smtovala.co.il/Transportation_of_industrial_and_heavy_generators",
    image:
      "https://smtovala.co.il/images/12.png"
  };

  return (
    <div className="Transportation_of_building_materials-page">

      {/* =====================================================
          SEO
      ===================================================== */}

      <Helmet>

        <title>{seo.title}</title>

        <meta
          name="description"
          content={seo.description}
        />

        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />

        <link
          rel="canonical"
          href={seo.url}
        />

        {/* Open Graph */}

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:title"
          content={seo.title}
        />

        <meta
          property="og:description"
          content={seo.description}
        />

        <meta
          property="og:url"
          content={seo.url}
        />

        <meta
          property="og:image"
          content={seo.image}
        />

        <meta
          property="og:site_name"
          content="ש.מ הובלות ומנופים"
        />

        <meta
          property="og:locale"
          content="he_IL"
        />

        {/* Twitter */}

        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content={seo.title}
        />

        <meta
          name="twitter:description"
          content={seo.description}
        />

        <meta
          name="twitter:image"
          content={seo.image}
        />

      </Helmet>


      <div className="Transportation_of_building_materials-hero">

        <div className="Transportation_of_building_materials-overlay">

          <h1>הובלת גנרטורים תעשייתיים </h1>

        </div>

      </div>


      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="page3">

        <div className="container">


          {/* =====================================================
              VIDEO - ראשון
          ===================================================== */}

          <div className="building-video-box">

            <div className="building-video-title">
              הובלת גנרטורים תעשייתיים
            </div>


          </div>


          {/* =====================================================
              TOP TEXT
          ===================================================== */}

          <h2 className="top-text">

            הובלת גנרטורים תעשייתיים היא משימה שדורשת תכנון מוקדם,
            התאמת אמצעי ההובלה והיכרות עם ההתמודדות מול ציוד כבד
            ומגושם. ש.מ הובלות ומנופים מעניקה שירותי הובלת גנרטורים
            לחברות, קבלנים, מפעלים, אתרי בנייה, עסקים ולקוחות פרטיים,
            תוך התאמת פתרון ההובלה למשקל הגנרטור, למידותיו ולתנאי הדרך.

          </h2>


          {/* =====================================================
              IMAGE + TEXT
          ===================================================== */}

          <div className="content-row">

            <div className="image-box">

              <img
                src="/images/12.png"
                alt="הובלת גנרטורים תעשייתיים כבדים"
              />

            </div>

            <div className="text-box">

              <p>
                גנרטור תעשייתי יכול להיות בעל משקל וממדים משמעותיים,
                ולכן העברתו ממקום למקום מחייבת בחירה נכונה של אמצעי
                ההובלה. לפני תחילת העבודה בודקים את מידות הגנרטור,
                המשקל, נקודת האיסוף, מקום הפריקה ואפשרויות הגישה
                לרכב ההובלה.
              </p>

              <p>
                ש.מ הובלות ומנופים מספקת פתרונות להובלת גנרטורים
                למפעלים, אתרי עבודה, מבנים מסחריים, אתרי בנייה
                ומתחמים פרטיים. בהתאם לצורך ניתן לשלב גם שירותי
                מנוף לצורך העמסה, פריקה או הצבה של הגנרטור בנקודה
                שנקבעה מראש.
              </p>

            </div>

          </div>


          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <h2 className="main-title">
            הובלת גנרטורים תעשייתיים – הכנה ותכנון של ההובלה
          </h2>

          <div className="bottom-text">

            <p>
              לפני הובלת גנרטור חשוב להכיר את מאפייני המטען ואת
              הדרך שבה ניתן להעביר אותו בבטחה. משקל, אורך, רוחב,
              גובה ומבנה הגנרטור הם חלק מהנתונים שיש לקחת בחשבון
              בעת תכנון ההובלה.
            </p>

            <p>
              בנוסף לכך, יש לבדוק את מסלול הנסיעה ואת תנאי האתר.
              כניסות צרות, שערים, חניות, מדרכות, אזורי תעשייה,
              אתרי בנייה ומקומות שבהם קיימת גישה מוגבלת עשויים
              להשפיע על אופן ביצוע העבודה ועל סוג הרכב או המנוף
              שיידרשו להובלה.
            </p>


            {/* =====================================================
                SECTION 2
            ===================================================== */}

            <h2 className="main-title">
              הובלת גנרטורים באמצעות משאית
            </h2>

            <p>
              משאית המותאמת למטען מאפשרת לבצע הובלה של גנרטורים
              תעשייתיים בין אתרים שונים. בחירת אמצעי ההובלה נעשית
              בהתאם למידות הגנרטור, למשקלו, לאופן ההעמסה ולתנאי
              הדרך הצפויים במהלך הנסיעה.
            </p>

            <p>
              כאשר נדרשת גם פעולת הרמה, ניתן לשלב במסגרת העבודה
              משאית עם מנוף מתאים. שילוב בין הובלה להרמה מאפשר
              לתת מענה גם כאשר אין אפשרות להכניס את הגנרטור
              ישירות לנקודת ההצבה באמצעות המשאית בלבד.
            </p>


            {/* =====================================================
                SECTION 3
            ===================================================== */}

            <h2 className="main-title">
              הובלת גנרטורים למפעלים, עסקים ואתרי בנייה
            </h2>

            <p>
              גנרטורים משמשים מפעלים, אתרי בנייה, עסקים, מבנים
              מסחריים ומתקנים שונים כמקור חשמל או כמערכת גיבוי.
              במקרים רבים יש צורך להעביר את הציוד לאתר חדש,
              להכניס אותו למתחם או להציב אותו באזור מוגדר.
            </p>

            <p>
              ש.מ הובלות ומנופים מבצעת הובלות של גנרטורים וציוד
              כבד למגוון לקוחות ברחבי הארץ. השירות מותאם למאפייני
              הפרויקט ולתנאים הקיימים באתר, החל מנקודת האיסוף ועד
              למקום הפריקה וההצבה.
            </p>


            {/* =====================================================
                SECTION 4
            ===================================================== */}

            <h2 className="main-title">
              הובלת גנרטורים בשילוב מנוף הרמה
            </h2>

            <p>
              כאשר הגנרטור צריך להגיע למקום שאינו נגיש למשאית,
              ניתן להיעזר במנוף לצורך הרמה והעברה אל נקודת ההצבה.
              פתרון כזה יכול להתאים לחצרות, אתרי בנייה, אזורים
              מוגבהים, מתחמים תעשייתיים ומקומות שבהם קיימת
              מגבלת גישה.
            </p>

            <p>
              שילוב שירותי הובלה ומנוף מאפשר לתכנן את העבודה
              כמענה אחד הכולל את העברת הגנרטור ואת פעולת ההרמה
              הנדרשת באתר. לפני ביצוע העבודה נבחנים תנאי השטח,
              מרחק ההרמה והמיקום שאליו יש להציב את הגנרטור.
            </p>


            {/* =====================================================
                SECTION 5
            ===================================================== */}

            <h2 className="main-title">
              העברת גנרטורים כבדים והצבתם באתר
            </h2>

            <p>
              מעבר להובלה עצמה, לעיתים נדרשת גם הצבה מדויקת של
              הגנרטור במיקום חדש. פעולה זו מחייבת להתחשב במידות
              המטען, במשקלו ובמרחב הקיים סביב נקודת ההצבה.
            </p>

            <p>
              ש.מ הובלות ומנופים מתאימה את אופן ביצוע העבודה
              לתנאים בשטח, כך שניתן יהיה לתכנן מראש את שלבי
              ההעמסה, ההובלה, הפריקה וההצבה בהתאם לדרישות הפרויקט.
            </p>


            {/* =====================================================
                SECTION 6
            ===================================================== */}

            <h2 className="main-title">
              למה חשוב לבחור חברה מנוסה להובלת גנרטורים?
            </h2>

            <p>
              גנרטור תעשייתי אינו מטען רגיל. מדובר בציוד כבד,
              ולעיתים גם גדול ומסורבל, ולכן תכנון לא נכון של
              ההובלה עלול להקשות על ההעמסה, הנסיעה או הפריקה.
              בדיקה מוקדמת של נתוני המטען ותנאי האתר מאפשרת
              להתכונן בצורה טובה יותר לביצוע העבודה.
            </p>

            <p>
              ש.מ הובלות ומנופים בוחנת את מאפייני ההובלה ומתאימה
              את הפתרון למשקל ולמידות הגנרטור, למסלול הנסיעה,
              לנקודת הפריקה ולצורך בשירותי מנוף. כך ניתן לתכנן
              את העבודה בהתאם לדרישות הפרויקט ולתנאים בפועל.
            </p>


            {/* =====================================================
                SECTION 7
            ===================================================== */}

            <h2 className="main-title">
              ש.מ הובלות ומנופים – הובלת גנרטורים תעשייתיים ברחבי הארץ
            </h2>

            <p>
              ש.מ הובלות ומנופים מעניקה שירותי הובלת גנרטורים
              תעשייתיים, מערכות גיבוי חשמל וציוד כבד עבור מפעלים,
              חברות, קבלנים, אתרי בנייה, עסקים ולקוחות פרטיים.
              השירות מתוכנן בהתאם למאפייני המטען ולתנאי המקום
              שבו מתבצעת ההובלה.
            </p>

            <p>
              צריכים להעביר גנרטור תעשייתי או ציוד חשמל כבד?
              צרו קשר עם ש.מ הובלות ומנופים, מסרו לנו את משקל
              ומידות הגנרטור, נקודת האיסוף והיעד, ונוכל לבחון
              עבורכם את הדרך המתאימה לביצוע ההובלה והפריקה.
            </p>

          </div>


          {/* =====================================================
              CONTACT
          ===================================================== */}

          <ContactSection2 />


          {/* =====================================================
              LINKS
          ===================================================== */}

          <div className="links">

            <Link
              to="/Container_Transportation"
              className="link-right"
            >
              הובלת מכולות
            </Link>

            <Link
              to="/Transportation_of_building_materials"
              className="link-left"
            >
              הובלת חומרי בניין
            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}
